module.exports = __webpack_public_path__ + "static/media/drop-slide-thumb-7.cb25f497.png";